import { useRef, useEffect } from 'react';
import Clipboard from 'clipboard';

const useClipboard = (callback?: () => void) => {
  const clipboardRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (clipboardRef.current) {
      new Clipboard(clipboardRef.current).on('success', () => {
        callback && callback();
      });
    }
  }, [callback]);

  return clipboardRef;
};

export default useClipboard;
